import {
  CARTPRODUCTADD,
  CARTPRODUCTREMOVE,
  CARTQTYDECREMENT,
  CARTQTYINCREMENT
} from "./actionTypes";

export const cartProductAdd = (product) => {
  return {
    type: CARTPRODUCTADD,
    product,
  };
};

export const cartProductRemove = (id) => {
  return {
    type: CARTPRODUCTREMOVE,
    id,
  };
};

export const cartQtyIncrement = (id, value) => {
  return {
    type: CARTQTYINCREMENT,
    id,
    value,
  };
};

export const cartQtyDecrement = (id, value) => {
  return {
    type: CARTQTYDECREMENT,
    id,
    value,
  };
};
